import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "form-group text-cl" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-plus" }, null, -1);
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = ["onUpdate:modelValue"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-minus" }, null, -1);
const _hoisted_7 = [
    _hoisted_6
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("label", null, _toDisplayString(_ctx.label), 1),
        _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-success ml-2",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                (...args) => (_ctx.add && _ctx.add(...args)))
        }, _hoisted_3),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (item, i) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "",
                key: i
            }, [
                _createTextVNode(_toDisplayString(i + 1) + ". ", 1),
                _withDirectives(_createElementVNode("input", {
                    class: "mr-2",
                    type: "text",
                    "onUpdate:modelValue": ($event) => ((_ctx.value[i]) = $event)
                }, null, 8, _hoisted_4), [
                    [_vModelText, _ctx.value[i]]
                ]),
                _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-danger ml-2",
                    onClick: ($event) => (_ctx.remove(i))
                }, _hoisted_7, 8, _hoisted_5)
            ]));
        }), 128))
    ]));
}
